<template>
  <div class="course box-radius box-shadow">
    <div class="course-part course-cover">
      <Cover :src="data.cover" raduis shadow />
    </div>
    <div class="course-part">
      <div class="course-info box-radius">
        <h2 class="course-info-title text-over">{{ data.title }}</h2>
        <ul class="course-info-list">
          <li class="list-item">
            <span class="text-bold">证书名称：</span>
            {{ data.certName }}
          </li>
          <li class="list-item">
            <span class="text-bold">考试名称：</span>
            {{ data.exam.name }}
          </li>
          <li class="list-item">
            <span class="text-bold">试题总量：</span>
            {{ data.exam.questionTotal }}
          </li>
          <li class="list-item">
            <span class="text-bold">考试总分：</span>
            {{ data.exam.totalScore }}
          </li>
          <li class="list-item">
            <span class="text-bold">考试时长：</span>
            {{ data.exam.timeLimit }}分钟
          </li>
          <li class="list-item">
            <span class="text-bold">及格分数：</span>
            {{ data.exam.passScore }}
          </li>
          <li class="list-item">
            <span class="text-bold">考试状态： </span>
            <span v-html="examStatus" />
          </li>
        </ul>

        <PassFlag
          v-if="passFlagData.show"
          :score="passFlagData.score"
          :passed="passFlagData.passed"
        />
      </div>
      <div class="course-buttons text-right">
        <p v-if="examDisabledTip">{{ examDisabledTip }}</p>
        <div>
          <Button
            v-if="
              data.exam.status === COURSE_STATUS.NO_EXAM ||
              !this.examScorePassed
            "
            class="margin-left-10px"
            type="primary"
            :disabled="examDisabled"
            @click="handleStartExam">参加考试</Button>
          <Button
            v-if="data.exam.status === COURSE_STATUS.COURSE_PASS || data.exam.hasDiploma"
            class="margin-left-10px"
            type="primary"
            @click="handleShowCertification">查看证书</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { COURSE_STATUS, A_DAY, HALF_YEAR } from '../../../libs/constant'
import { USER } from '../../../libs/namespace'
import PassFlag from '../../../components/PassFlag'
import Cover from '../../../components/Cover'

export default {
  components: { PassFlag, Cover },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      COURSE_STATUS
    }
  },
  computed: {
    ...mapState([ 'canExam', 'now' ]),
    ...mapState(USER, [ 'userInfo' ]),
    examDisabled () {
      return !this.canExam || this.data.exam.status !== COURSE_STATUS.NO_EXAM
    },
    examScorePassed () {
      return this.data.exam.passScore <= this.data.exam.score
    },
    examDisabledTip () {
      const status = this.data.exam.status
      const hasPassed = this.examScorePassed
      if (status === COURSE_STATUS.NO_BOUGHT) return '未报名参加该考试'
      if (status === COURSE_STATUS.NO_PASS && !hasPassed) return '未通过该课程考试，如需补考请先缴纳补考费用'
      if (status === COURSE_STATUS.EXAM_TIMEOUT) return '当前考试有效期已过，如需补考请先缴纳补考费用'
      if (!this.canExam && this.now) return '非考试日，无法参加该课程考试'
      return ''
    },
    examStatus () {
      const status = this.data.exam.status
      const hasPassed = this.examScorePassed
      if (status === COURSE_STATUS.NO_BOUGHT) return '未报名参加该考试'
      if (status === COURSE_STATUS.NO_EXAM) return `未参考，剩余有效期 <span class="text-bold text-theme">${
        parseInt((HALF_YEAR - (this.now - this.data.payTime)) / A_DAY)
      }天</span>`
      if (status === COURSE_STATUS.NO_PASS) return hasPassed ? '已获得证书，最近一次未通过' : '已参考，未通过考试'
      if (status === COURSE_STATUS.COURSE_PASS) return '已获得证书'
      if (status === COURSE_STATUS.EXAM_TIMEOUT) return hasPassed ? '最近一次考试已过期，已获得证书' : '考试已过期'
      return ''
    },
    passFlagData () {
      return {
        show: [ COURSE_STATUS.COURSE_PASS, COURSE_STATUS.NO_PASS ].indexOf(this.data.exam.status) > -1 || this.data.exam.hasDiploma,
        score: this.data.exam.score,
        passed: this.data.exam.score >= this.data.exam.passScore
      }
    }
  },
  handlers: {
    async handleShowCertification () {
      this.$router.push({
        name: 'certification',
        params: {
          courseId: this.data.courseId
        }
      })
    },
    async handleStartExam () {
      if (!this.userInfo.idCardSeriesNo) {
        const flag = await window.confirm({
          title: '个人信息未完善',
          content: `
            <p class="text-paragraph">您当前的身份信息还未完善，将导致以下功能无法正常使用：</p>
            <p class="text-bold text-indent">1、考试功能</p>
            <p class="text-bold text-indent">2、电子证书发放</p>
            <p class="text-bold text-indent">3、实体证书寄送</p>
          `
        })
        if (flag) {
          this.openDialog({
            name: '/user/dialogs/userInfo'
          })
        }
        return
      }
      this.openDialog({
        name: '/dialogs/browserTest',
        data: {
          courseId: this.data.courseId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.course {
  display: -webkit-box !important;
  display: flex;
  // align-items: stretch;
  width: 600px;
  margin: 20px auto;
  padding: 20px;
  background: #ffffff;

  &-part {
    flex: auto;
  }
  &-cover {
    flex: none;
    margin-right: 20px;
  }
  &-info {
    position: relative;
    flex: auto;
    display: flex;
    flex-direction: column;
    min-height: 200px;
    // padding: 10px;
    // background: #ffffff;

    &-title {
      flex: none;
      width: 410px;
      line-height: 1.5;
      margin-bottom: 10px;
    }
    &-list {
      flex: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding-left: 10px;
    }
  }
  &-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;
    padding-left: 10px;
  }
}
</style>
